import React, { PureComponent } from 'react';
import Transition from 'react-transition-group/Transition';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import PropType from 'prop-types';
import amplitude from 'amplitude-js/amplitude';
import { SCROLL_WORKOUT_PHOTOS } from '../../constants/amplitudeEvents';
import Icon from '../Icon/Icon';

const duration = 300;
const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};
const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
};

export default class Images extends PureComponent {
  state = {
    selected: 0,
  }

  browse = (next) => {
    let selected = next;
    if (next < 0) {
      selected = this.props.images.length - 1;
    } else if (next > this.props.images.length - 1) {
      selected = 0;
    }
    amplitude.getInstance().logEvent(SCROLL_WORKOUT_PHOTOS, { TargetOrder: selected });
    return this.setState(() => ({ selected }));
  }

  render() {
    const {
      images, hasNoControls, hasOverflowHidden, isCroppedNotStretched,
    } = this.props;
    return (
      <div className={`is-relative workout-photos image-container ${!hasNoControls ? 'has-pagination' : ''}`}>
        {!hasNoControls && images.length > 1 && (
        <nav className="pagination image-pagination is-overlay is-centered" aria-label="pagination">
          <a role="button" tabIndex="0" className="pagination-previous" onClick={() => this.browse(-1 + this.state.selected)}><Icon color="#FFF" codePoint="0xf153" /></a>
          <a role="button" tabIndex="0" className="pagination-next" onClick={() => this.browse(1 + this.state.selected)}><Icon color="#FFF" codePoint="0xf154" /></a>
          <p className="pagination-counter is-absolute is-fullwidth has-text-centered title is-6">
            {this.state.selected + 1}
            {' '}
            /
            {images.length}
          </p>
          <ul className="pagination-list">
            {images.map((image, index) => (
              <li key={image.key}>
                <a
                  role="button"
                  tabIndex="0"
                  className={`pagination-link ${index === this.state.selected ? 'is-current' : ''}`}
                  aria-label={`Goto image ${index + 1}`}
                  onClick={() => this.browse(index)}
                >
                  <span>{index + 1}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
        )}
        <figure className={`image is-16by9 ${isCroppedNotStretched ? 'is-cropped' : ''} ${hasOverflowHidden ? 'has-overflow-hidden' : ''}`}>
          <TransitionGroup>
            {images.slice(this.state.selected, this.state.selected + 1).map((image) => (
              <Transition key={image.key} timeout={{ enter: 300, exit: 500 }}>
                {(state) => <img style={{ ...defaultStyle, ...transitionStyles[state] }} src={image.url} alt={image.description} />}
              </Transition>
            ))}
          </TransitionGroup>
        </figure>

      </div>
    );
  }
}
Images.defaultProps = {
  hasNoControls: false,
  hasOverflowHidden: false,
  isCroppedNotStretched: false,
};
Images.propTypes = {
  images: PropType.array.isRequired,
  hasNoControls: PropType.bool,
  hasOverflowHidden: PropType.bool,
  isCroppedNotStretched: PropType.bool,
};
